<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('buCoupon:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
                <a-form-item label="兑换码">
                  <a-input v-model="queryParam.exchangeCode" allow-clear placeholder="请输入兑换码"/>
                </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建日期">
                <a-date-picker  show-time  style="width: 100%" placeholder="请选择创建日期" v-model="queryParam.createTime"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择状态" :options="couponStatus"></a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="劵编号">
                <a-input v-model="queryParam.code" allow-clear placeholder="请输入劵编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="券名称">
                <a-input v-model="queryParam.name" allow-clear placeholder="请输入券名称"/>
              </a-form-item>
            </a-col>
           
              <a-col :md="8" :sm="24">
                <a-form-item label="有效期">
                  <a-date-picker style="width: 100%" placeholder="请选择有效期" v-model="queryParam.validDate"/>
                </a-form-item>
              </a-col>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('buCoupon:add')" >
          <a-button type="primary" v-if="hasPerm('buCoupon:add')" icon="plus" @click="$refs.addForm.add()">创建优惠券</a-button>
          <!-- <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('buCoupon:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button> -->
          <x-down
            v-if="hasPerm('buCoupon:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
        <span slot="amount" slot-scope="text, record" style="color:#D9001BA5">
            {{ (Number(record.amount)).toFixed(2) }}
        </span>
        <span slot="status" slot-scope="text, record">
            {{ record.status == '0' ? '未激活' : record.status == '1' ? '已激活' : record.status
            == '2' ? '已使用' : record.status == '3' ? '已过期' : '---' }}
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- <a v-if="hasPerm('buCoupon:edit')" @click="$refs.editForm.edit(record)">编辑</a> -->
          <a @click="$refs.detialForm.add(record)" style="margin-right: 10px;" v-if="record.status != '0'">详情</a>
          <!-- <a-divider type="vertical" v-if="hasPerm('buCoupon:edit') & hasPerm('buCoupon:delete')"/> -->
          <a-popconfirm v-if="hasPerm('buCoupon:delete') && (record.status == '0' || record.status == '3')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)" >
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
      <detial-form ref="detialForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { buCouponPage, buCouponDelete, buCouponExport } from '@/api/modular/interhospital/bucoupon/buCouponManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  import detialForm from './viewDetial.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      detialForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        couponStatus : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '未激活',
          },
          {
            value: '1',
            label: '已激活',
          },
          {
            value: '2',
            label: '已使用',
          },
          {
            value: '3',
            label: '已过期'
          }
        ],
        // 表头
        columns: [
          {
            title: '劵编号',
            align: 'center',
            dataIndex: 'code'
          },
          {
            title: '券名称',
            align: 'center',
            dataIndex: 'name'
          },
          {
            title: '金额',
            align: 'center',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' }
          },
          {
            title: '兑换码',
            align: 'center',
            dataIndex: 'exchangeCode'
          },
          {
            title: '有效期',
            align: 'center',
            dataIndex: 'validDate'
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' }
          },
          // {
          //   title: '使用标记（0-停用 1-使用）',
          //   align: 'center',
          //   dataIndex: 'useflag'
          // },
          {
            title: '创建日期',
            align: 'center',
            dataIndex: 'createTime'
          },
          
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return buCouponPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('buCoupon:edit') || this.hasPerm('buCoupon:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamvalidDate = this.queryParam.validDate
        const queryParamcreateTime = this.queryParam.createTime
        if (queryParamvalidDate && queryParamvalidDate != null) {
            this.queryParam.validDate = moment(queryParamvalidDate).format('YYYY-MM-DD')
            if (queryParamvalidDate.length < 1) {
                delete this.queryParam.validDate
            }
        }
        if (queryParamcreateTime && queryParamcreateTime != null) {
            this.queryParam.createTime = moment(queryParamcreateTime).format('YYYY-MM-DD HH:mm:ss')
            if (queryParamcreateTime.length < 1) {
                delete this.queryParam.validDate
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = { 'couponId': record.id }
        this.buCouponDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.buCouponDelete(paramIds)
      },
      buCouponDelete (record) {
        buCouponDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /**
       * 批量导出
       */
      batchExport () {
        if(this.selectedRowKeys.length === 0){
          this.$message.error('请勾选要导出的优惠券') 
        }
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        buCouponExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
